exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-6beed8bc]:export{menuText:#606266;menuActiveText:#fa8c16;subMenuActiveText:#fa8c16;menuBg:#fff;menuHover:#fff7e6;subMenuBg:#fafafa;subMenuHover:#fff7e6;sideBarWidth:220px;primaryColor:#fa8c16;bgColor:#fdfbf7}.app-main[data-v-6beed8bc]{min-height:calc(100vh - 94px);width:100%;position:relative;overflow-x:hidden;overflow-y:auto;background-color:#fdfbf7;padding:0}.fixed-header+.app-main[data-v-6beed8bc]{padding-top:94px}.hasTagsView .app-main[data-v-6beed8bc]{min-height:calc(100vh - 94px)}.hasTagsView .fixed-header+.app-main[data-v-6beed8bc]{padding-top:94px}", ""]);

// exports
